export enum AppPlatform {
    WEB,
    ANDROID,
    IOS,
    ReactNative,
}
